export default __webpack_public_path__ + "static/media/factor_item_5.dd1c1e02.png";